import env from '@/env';
export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
     * @description 上传图片
     * @description http://yapi.xiya.vip/project/11/interface/api/235
     */
    UPLOAD_IMAGE: function UPLOAD_IMAGE(image) {
      var data = new FormData();
      data.append('file', image);
      return request({
        // url: '/api/upload/pic',
        // url: 'http://192.168.0.120:8011' + '/pic',
        url: env.VUE_APP_PIC + '/api/upload/pic',
        method: 'post',
        header: {
          'Content-Type': 'multipart/form-data'
        },
        data: data
      });
    },
    UPLOAD_VEDIO: function UPLOAD_VEDIO(video) {
      var data = new FormData();
      data.append('file', video);
      return request({
        // url: '/api/upload/pic',
        // url: 'http://192.168.0.120:8011' + '/pic',
        url: env.VUE_APP_PIC + '/api/upload/video',
        method: 'post',
        header: {
          'Content-Type': 'multipart/form-data'
        },
        data: data
      });
    },
    UPLOAD_APK: function UPLOAD_APK(apk) {
      var data = new FormData();
      data.append('file', apk);
      return request({
        // url: '/api/upload/pic',
        // url: 'http://192.168.0.120:8011' + '/pic',
        url: env.VUE_APP_PIC + '/api/upload/apk',
        method: 'post',
        header: {
          'Content-Type': 'multipart/form-data'
        },
        data: data
      });
    },

    /**
     * @description 上传图片到百度 OOS
     * @description http://yapi.xiya.vip/project/11/interface/api/460
     */
    UPLOAD_IMAGE_OOS: function UPLOAD_IMAGE_OOS(image) {
      var data = new FormData();
      data.append('file', image);
      return request({
        url: '/api/upload/BaiduOSS',
        method: 'post',
        header: {
          'Content-Type': 'multipart/form-data'
        },
        data: data
      });
    }
  };
});